export default __webpack_public_path__ + "static/about-us-support-3-f740b76952a52cf821a9a1f10d15c67b.png";